var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "row form-group" }, [
      _c(
        "div",
        { staticClass: "col-6" },
        [
          _c("settings-property", {
            scopedSlots: _vm._u([
              {
                key: "label",
                fn: function(ref) {
                  var id = ref.id
                  return [
                    _c("label", { attrs: { for: id } }, [
                      _vm._v(
                        _vm._s(
                          _vm.resource(
                            "JourneyBuilder_TimerSettings_Date_Label"
                          )
                        )
                      )
                    ])
                  ]
                }
              },
              {
                key: "input",
                fn: function(ref) {
                  var id = ref.id
                  return [
                    _c("date-picker", {
                      attrs: {
                        options: {
                          disabled: !_vm.canWrite,
                          typeable: false,
                          id: id
                        }
                      },
                      model: {
                        value: _vm.dateModel,
                        callback: function($$v) {
                          _vm.dateModel = $$v
                        },
                        expression: "dateModel"
                      }
                    })
                  ]
                }
              },
              {
                key: "errors",
                fn: function() {
                  return [
                    _vm.$v.date.$dirty && _vm.$v.date.$invalid
                      ? _c("required-error-message")
                      : _vm._e()
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-6" },
        [
          _c("settings-property", {
            scopedSlots: _vm._u([
              {
                key: "label",
                fn: function() {
                  return [
                    _c("label", [
                      _vm._v(
                        _vm._s(
                          _vm.resource(
                            "JourneyBuilder_TimerSettings_Time_Label"
                          )
                        )
                      )
                    ])
                  ]
                },
                proxy: true
              },
              {
                key: "input",
                fn: function() {
                  return [
                    _c("time-picker", {
                      attrs: { readonly: !_vm.canWrite },
                      model: {
                        value: _vm.timeModel,
                        callback: function($$v) {
                          _vm.timeModel = $$v
                        },
                        expression: "timeModel"
                      }
                    })
                  ]
                },
                proxy: true
              },
              {
                key: "errors",
                fn: function() {
                  return [
                    _vm.$v.time.$dirty && _vm.$v.time.$invalid
                      ? _c("required-error-message")
                      : _vm._e()
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row form-group" }, [
      _c("div", { staticClass: "col-12" }, [_c("hr")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }